import CompoundMarkEditor from "Components/CompoundMarkEditor";

const BetaPage = () => {


  return (
    <>
      <div className="container">
        <div className="content-wrap popup">
          <CompoundMarkEditor />
        </div>
      </div>
    </>
  );
};

export default BetaPage;
